<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="data-list-list-view" class="data-list-container">
  <!-- compose email -->
        <vs-prompt
            class="email-compose"
            :title="$t('NewMessage')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="initValues"
            @accept="submitData"
            @close="initValues"
            :is-valid="validateForm"
            :active.sync="activePrompt">
                <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="max-height:75vh">
                       <vx-card title="Variables guids" class="mb-base">
                               <P> [CourseName], [CourseCode], [StartDate] , [EndDate], [RecieverName], [Price]</P>
                               <P> [InstructorName], [TraineeName], [OrganizationName] , [ExamName]</P>
                          </vx-card>

                      <br/>
                            <label class="text-sm opacity-75">{{$t('MailType')}}</label>
          <v-select
            class="w-full"
            v-model="MailModel.SystemMailTemplateTypeID"
            :options="MailTypes"
            autocomplete
            :reduce="value => value.value"
          />

                        <!-- <vs-input v-validate="'required|email'" name="mailTo" label-placeholder="To" v-model="mailTo" class="w-full mb-6" :danger="!validateForm && mailTo != ''" val-icon-danger="clear" :success="validateForm" val-icon-success="done" :color="validateForm ? 'success' : 'danger'" /> -->
                        <vs-input name="mailSubject" :label-placeholder="$t('Subject')" v-model="MailModel.Subject" class="w-full mb-6" />
                        <!-- <vs-input name="mailCC" label-placeholder="CC" v-model="mailCC" class="w-full mb-6" /> -->
                        <!-- <vs-input name="mailBCC" label-placeholder="BCC" v-model="mailBCC" class="w-full mb-6" /> -->
                        <quill-editor v-model="MailModel.Body" :options="editorOption" />
                        <!-- <vs-upload multiple text="Attachments" :show-upload-button="false" class="compose-mail-attachment" />  -->
                   <vs-button class="ml-5 mt-4"  type="border" color="danger" @click="ShowStatusSystemMailTemplatePreview=!ShowStatusSystemMailTemplatePreview">{{ShowStatusSystemMailTemplatePreview?'Hide':'Preview'}}</vs-button>

  <vx-card v-if="ShowStatusSystemMailTemplatePreview" class="mt-5">
               <p style="max-width: 70%;margin: auto;" v-html="MailModel.Body"></p>
            </vx-card>
                    </form>
                </VuePerfectScrollbar>
        </vs-prompt>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search :data="SystemMailTemplates">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="activePrompt = true">{{$t('AddNew')}}</vs-button>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ SystemMailTemplates.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : SystemMailTemplates.length }} of {{ SystemMailTemplates.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
         <vs-th sort-key="Name">{{$t('MailType')}}</vs-th>
        <vs-th sort-key="Name">{{$t('Subject')}}</vs-th>

        <vs-th>{{$t('Action')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click="editData(tr)">
               <vs-td>
                <p v-if="tr.SystemMailTemplateType!=undefined" class="product-name font-medium truncate">{{ tr.SystemMailTemplateType.Name }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Subject }}</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="openConfirm(tr)" />
              </vs-td>

            </tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleSystemMailTemplate from "@/store/settings/systemMailTemplate/moduleSystemMailTemplate.js";
import {toolbar } from '@/gloabelConstant.js'
import vSelect from "vue-select";
export default {
  components: {
    quillEditor,
    VuePerfectScrollbar,
    vSelect
  },
  data() {
    return {
   ShowStatusSystemMailTemplatePreview:false,
       editorOption: {
        modules: {
          toolbar: toolbar
        },
        placeholder: 'Message'
      },
       settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      selected: [],
     activePrompt:false,
      itemsPerPage: 10,
      isMounted: false,
      MailTypes : [
          { label: $t('MailType1'), value: 1 },
        { label: $t('MailType2'), value: 2 },
        { label: $t('MailType3'), value: 3 },
        { label: $t('MailType4'), value: 4 },
        { label: $t('MailType5'), value: 5 },
        { label: $t('MailType6'), value: 6 },
        { label: $t('MailType7'), value: 7 },
        { label: $t('MailType8'), value: 8 },
        { label: $t('MailType9'), value: 9 },
        { label: $t('MailType10'), value: 10 },

        ],
      rowDataForDelete: {},
      activeConfirm: false,
      MailModel:{},
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    SystemMailTemplates() {
      return this.$store.state.SystemMailTemplateList.SystemMailTemplates;
    },
    validateForm(){
       return  this.MailModel.Subject !=undefined && this.MailModel.Body != undefined
      },
  },

  methods: {
    submitData() {
   this.ShowStatusSystemMailTemplatePreview=false;
          if (this.MailModel.ID !== null && this.MailModel.ID >= 0) {
            this.$store.dispatch("SystemMailTemplateList/updateItem", this.MailModel)
            .then(()=>{
              this.$store.dispatch("SystemMailTemplateList/fetchDataListItems");
            })
            .catch(err => {
              console.error(err);
            });
          } else {
            this.$store.dispatch("SystemMailTemplateList/addItem", this.MailModel)
             .then(()=>{
              this.$store.dispatch("SystemMailTemplateList/fetchDataListItems");
            }).catch(err => {
              console.error(err);
            });
          }
          this.activePrompt=false;
          this.initValues();
          //this.$store.dispatch("foodTypeList/fetchfoodTypeListItems");
        },

        initValues(){
               this.MailModel={};
               this.ShowStatusSystemMailTemplatePreview=false;
        },

    deleteData(data) {
      this.$store.dispatch("SystemMailTemplateList/removeItem", data)
       .then(()=>{
              this.$store.dispatch("SystemMailTemplateList/fetchDataListItems");
            })
      .catch(err => {
        console.error(err);
      });
    },

    editData(data) {
        this.$store.dispatch("SystemMailTemplateList/GetItemByID", data.ID)
      .then(res => {
        this.MailModel = res.data;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) })
       this.activePrompt=true;
    },



    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title:  this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert
      });
    },

    acceptAlert() {
      this.deleteData(this.rowDataForDelete);
      this.$vs.notify({ time:8000,
        color: "danger",
        title:this.$t("Deletedrecord") ,
       text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    }
  },

  created() {
    if (!moduleSystemMailTemplate.isRegistered) {
      this.$store.registerModule("SystemMailTemplateList", moduleSystemMailTemplate);
      moduleSystemMailTemplate.isRegistered = true;
    }
    this.$store.dispatch("SystemMailTemplateList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
